module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tasks text-dark",
    class: {
      'tasks--with-kids': _vm.isWithKids
    }
  }, [_c('div', {
    staticClass: "tasks-header"
  }, [_c('h4', [_vm._v("Personalets kalender")]), _vm._v(" "), _c('button', {
    class: {
      'submit-button create-btn': !_vm.isWithKids
    },
    on: {
      "click": _vm.setCreateNewTask
    }
  }, [_vm._v("\n      Opret opgave for personale\n    ")]), _vm._v(" "), (_vm.isTaskModal) ? _c('CreateTask', {
    attrs: {
      "editTask": _vm.theEditTask,
      "activeFilter": _vm.theActiveFilter
    },
    on: {
      "create": _vm.createTask,
      "close": _vm.closeUpdateTask
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "d-table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedTasksWithProps), function(task) {
    return _c('tr', {
      key: task.id
    }, [_c('td', {
      staticClass: "task__task"
    }, [_c('div', {
      staticClass: "task__name"
    }, [_c('div', {
      class: [{
        'td-subject--hidden': !task.can_schedule
      }, {
        'td-subject': task.can_schedule
      }],
      style: ({
        'background-color': task.color
      }),
      on: {
        "click": function($event) {
          return _vm.setEditTask(task)
        }
      }
    }, [_vm._v(_vm._s(task.name) + "\n          ")])])]), _vm._v(" "), _c('td', {
      staticClass: "task__hours"
    }, [_vm._v(_vm._s(task.hours))]), _vm._v(" "), _c('td', {
      staticClass: "task__calendars",
      class: {
        'd-select-lookalike': !task.v_is_active_d_select && task.v_staff_names.length < 1
      },
      attrs: {
        "aria-placeholder-label": "Søg og vælg"
      },
      on: {
        "click": function($event) {
          return _vm.setActiveDSelect(task)
        }
      }
    }, [(task.v_is_active_d_select) ? _c('DSelectCalendarIds', {
      directives: [{
        name: "on-clickaway",
        rawName: "v-on-clickaway",
        value: (_vm.closeDSelect),
        expression: "closeDSelect"
      }, {
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          onShow: function () { return _vm.usersWithEvents(task).length > 0; },
          arrow: true,
          placement: 'bottom'
        }),
        expression: "{\n                              onShow: () => usersWithEvents(task).length > 0,\n                              arrow: true,\n                              placement : 'bottom'\n                            }"
      }],
      attrs: {
        "show": _vm.activeDSelectShow,
        "itemType": "USER",
        "preSelectedItems": task.user_calendar_ids,
        "itemsThatCantBeDeleted": _vm.usersWithEvents(task),
        "showTags": false,
        "content": _vm.getUserNames(_vm.usersWithEvents(task)) + ' har skemalagte aktiviteter og kan ikke slettes'
      },
      on: {
        "update": function($event) {
          return _vm.setSelectedUsers($event, task)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!task.v_is_active_d_select && task.v_staff_names.length > 0) ? _c('div', {
      staticClass: "task__users"
    }, _vm._l((task.v_staff_names), function(user) {
      return _c('p', [_vm._v(_vm._s(user))])
    }), 0) : _vm._e()], 1)])
  }), 0)]), _vm._v(" "), (_vm.tasks.length < 1) ? _c('div', {
    staticClass: "explainer-div"
  }, [_vm._v("Ikke oprettet nogen opgaver uden børn")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "task__task"
  }, [_vm._v("Opgave")]), _vm._v(" "), _c('th', {
    staticClass: "task__hours"
  }, [_vm._v("Timer")]), _vm._v(" "), _c('th', {
    staticClass: "task__calendars"
  }, [_vm._v("Personale")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-223d07fd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnnualNorm/AnnualNormWithoutKids.vue
// module id = 1504
// module chunks = 1